import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/2c7f9303/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` Please direct all questions regarding support, bug fixes, and feature requests to the `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts#core-team"
        }}>{`Carbon Charts core team`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Development options</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Other frameworks</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Download WIP charting design specifications (IBM internal link)" disabled mdxType="ResourceCard">
    <MdxIcon name="sketch" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Data visualization color palettes (IBM internal link)" href="https://ibm.box.com/s/3mt8fshtgy70r7rhxjhfo3gbdt0n3x5y" actionIcon="download" mdxType="ResourceCard">
    <MdxIcon name="sketch" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h2 {...{
      "id": "development-options"
    }}>{`Development options`}</h2>
    <p>{`The Carbon Design System supports vanilla JS, React and Angular as core parts of the product. But you can still build components even if you’re using a different framework.`}</p>
    <AnchorLinks small mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Wrapping components with JavaScript frameworks</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Examples</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Troubleshooting</AnchorLink>
    </AnchorLinks>
    <h3 {...{
      "id": "wrapping-components-with-javascript-frameworks"
    }}>{`Wrapping components with JavaScript frameworks`}</h3>
    <p>{`Many JavaScript frameworks have a mechanism to dynamically create/destroy DOM elements, for example, upon change in an array.`}</p>
    <p>{`In order to develop wrappers of the Carbon Charts components in a framework of your choice, you’d need to initialize the chart through the vanilla library (`}<inlineCode parentName="p">{`@carbon/charts`}</inlineCode>{`), and update data/options upon receiving updated values through the framework you are using.`}</p>
    <p>{`Also when DOM elements that Carbon Charts components have been instantiated on are being destroyed, the component instances should be released so that e.g. there are no zombie event handlers.`}</p>
    <p>{`The easiest way to hook on the creation/destruction of DOM elements is by defining a “wrapping component”, with the JavaScript framework of your choice.`}</p>
    <h3 {...{
      "id": "examples"
    }}>{`Examples`}</h3>
    <p>{`Below are links to various wrappers to the Vanilla `}<inlineCode parentName="p">{`StackedBarChart`}</inlineCode>{` component:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts/blob/master/packages/react/src/bar-chart-stacked.js"
        }}>{`React`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts/blob/master/packages/angular/src/bar-chart-stacked.component.ts"
        }}>{`Angular`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts/blob/master/packages/vue/src/ccv-stacked-bar-chart.vue"
        }}>{`Vue`}</a></li>
    </ul>
    <h3 {...{
      "id": "troubleshooting"
    }}>{`Troubleshooting`}</h3>
    <p>{`If you experience any issues while getting set up with Carbon Charts, please head over to the `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-charts"
      }}>{`GitHub repo`}</a>{` for more guidelines and support. Please `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon-charts/issues"
      }}>{`create an issue`}</a>{` if your issue does not already exist.`}</p>
    <h2 {...{
      "id": "other-frameworks"
    }}>{`Other frameworks`}</h2>
    <p>{`We are open to the idea of providing core support for additional frameworks in future.`}</p>
    <p>{`For the Carbon Design System to incorporate additional frameworks into our core offering, those frameworks need clear, guaranteed, ongoing resources to maintain and support that option. If a team built a product using a native web components implemenation of Carbon Charts, for example, but had no plan to support that solution outside of their product, that couldn’t become a core part of the Carbon Design System.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      